import "../style/home/H_Features.css";
import video1 from "../../assets/home/video.mp4";
import { FaPlay } from "react-icons/fa";

// import video_cover from '../../assets/home/olia-gozha-jmm8F_V9tiA-unsplash.jpg';

let features = [
  {
    id: 1,
    title: "سرعت و دقت",
    subtitle:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.",
  },
  {
    id: 2,
    title: "پیشرفته در عین حال ساده",
    subtitle:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.",
  },
  {
    id: 3,
    title: "دربردارنده کلیه کتاب‌ها",
    subtitle:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.",
  },
  {
    id: 4,
    title: "اساتید مجرب",
    subtitle:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.",
  },
];

const H_Features = () => {
  const play_video = () => {
    document.querySelector(".h-features-video-container-cover").style.display =
      "none";
    document.querySelector(".h-features-video").play();
  };
  return (
    <div className="h-features">
      <div className="h-features-video-container">
        <div className="h-features-video-container-cover">
          {/* <img className="h-features-video-container-cover-img" src={video_cover} alt="video-cover" /> */}
          <div className="hfvcc-play-btn" onClick={play_video}>
            <FaPlay className="hfvcc-play-btn-icon" />
          </div>
        </div>
        <video className="h-features-video" width="650" height="350" controls>
          <source src={video1} />
        </video>
      </div>
      <div className="h-features-text">
        {features.map((item) => (
          <div key={item.id} className="h-features-text-item">
            <div className={`hfti-number hfti-number${item.id}`}>{item.id}</div>
            <div className="hfti-title">{item.title}</div>
            <div className="hfti-subtitle">{item.subtitle}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default H_Features;
